// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../components/icons/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `                                                                           @font-face {
  font-family: 'PlusJakartaSans'; /* Choose a name for your font */
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  /* Additional font properties can be specified, such as font-weight, font-style, etc. */
}
.overview-main{
    padding-left: 25px;
    padding-right: 25px;
    padding-top: 10px;
    display:flex;
    flex-direction: column;

    gap:20px;
    align-items: center;
    background-color: rgb(248, 248, 255);
        width: 100%;
        height:100%;
      overflow-y: auto;    
      font-family: 'PlusJakartaSans'; 
  }

.card-text{
  width: 65%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  height: 100%;
}
.card-container{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap:20px;
    width:100%;

  }

  .report-card-container{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap:30px;
    padding-top: 10px;
    font-family: 'PlusJakartaSans'; 

  }
.graph-card{
    /* margin-top: 25px; */
    padding-left: 30px;
    padding-right: 30px;
    background: var(--Theme-Colors-White, #fff);
    border-radius: 4px !important;
    border: 1px solid #d6d6d6;
    box-shadow: none !important;
    font-family: 'PlusJakartaSans'; 
    width:100%;
    height: 332px;
}

  .overview-card{
    height: 105px;
    background: var(--Theme-Colors-White, #fff);
    border-radius: 11px !important;
    border: 1px solid #d6d6d6;
    box-shadow: none !important;
  }
  .heading-container{
    padding-top: 10px;
    display: flex;
    width:100%;
    align-items: center;
    justify-content: flex-start;
  }
.heading{
  font-family: PlusJakartaSans; 
 font-size: 24px;
 font-style: normal;
 font-weight: 500;

}
  .overview-card-details{
    margin:40px
}

.apexcharts-zoom-icon,
.apexcharts-pan-icon,
.apexcharts-reset-icon,
.apexcharts-menu-icon {
  display: none;
}

.card-img{
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-align{
    display: flex;
    align-items: center;
    padding-top: 23px;

}

.recent-card-text{
font-size: 12px;
font-weight: 500;
font-family: PlusJakartaSans;
}

.overview-card-text{
  font-family: PlusJakartaSans !important; 
    font-size: 14px !important;
    font-weight: 500 !important;
}

.overview-header{
  font-family: PlusJakartaSans !important; 
    font-size: 16px !important;
    font-weight: bold !important;
    letter-spacing: 0em !important;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: 15px;
    margin-bottom: 0px;

}

.overview-card-defect{
  font-family: PlusJakartaSans !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  letter-spacing: 0em !important;
  white-space: nowrap; /* Prevent text from wrapping to the next line */
  overflow: hidden; /* Hide any overflowed text */
  text-overflow: ellipsis; 
}
.card-count{
    color: #000;
    font-family: "PlusJakartaSans";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.card-image{
    width: 45px;
    height: 45px;
}

.card-content {
  padding: 0px !important;
  padding-bottom: 0px !important; 
}

.report-main-card{
  /* margin-top: 25px; */
  padding-left: 30px;
  padding-right: 30px;
  height: 230px;
  background: var(--Theme-Colors-White, #fff);
  border-radius: 4px !important;
  border: 1px solid #d6d6d6;
  box-shadow: none !important;
  margin-bottom: 30px;
  width:100%;

}

.report-card{
  height: 158px;
  background: var(--Theme-Colors-White, #fff);
  border: 1px solid #d6d6d6;
  box-shadow: none !important;
  display: flex;
  gap: 30px;
  align-items: center;
  padding: 20px;
}

.card-column{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.show-more-link{
  display: flex;
    align-items: center;
    justify-content: center;
}

.report-image {
  height: 100%;
  width: 100%;
  border-radius: 8px;
  object-fit: cover; /* This ensures the image covers the entire container, maintaining its aspect ratio */
}

.report-image-div{
  height: 100%;
  width: 40%;
  border-radius: 8px;
}
.report-text-content{
  width: 60%;
}
.report-text{
  display: flex;
  align-items: center;
  gap:20px;    margin: 10px;
}
.apexcharts-canvas{
  height:240px;
  min-height:100%;
}
#chart-container .apexcharts-xaxis .apexcharts-gridline {
  stroke-width: 0.1;
}

#chart-container .apexcharts-xaxis-line {
  stroke-width: 0px !important; /* Adjust the thickness as needed */
}

.react-line-chart{
  height: 85% !important}

  @media screen and (max-width: 1800px) and (min-width: 1600px) {
.overview-card-defect{
  font-size: 16px !important;
}
    
  }
@media screen and (max-width: 1600px) and (min-width: 1350px) {
  /* Your styles go here */
  .overview-card-defect{
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .overview-card-text{
      font-size: 12px !important;
      font-weight: 500 !important;
  }

.recent-card-text{
  font-size: 10px;
}
.report-text{
  align-items: center;
  gap:10px; 
  margin: 5px;
  width:100%;
}
.report-card{
  gap:15px
}
  /* Add more styles as needed */
}


@media screen and (max-width: 1350px) and (min-width: 1000px) {
  /* Your styles go here */
  .overview-card-defect{
    font-size: 12px !important;
    font-weight: 600 !important;
  }
  .overview-card{
    height: 90px;

  }
  .overview-card-text{
      font-size: 10px !important;
      font-weight: 400 !important;
  }



.card-container {
  gap:15px;
  padding:0px;
}
.report-main-card{
  height:208px;
}
.report-card-container{
  padding-top:0.5rem;
  padding-bottom:0.5rem;
}
.report-card{
  height:auto;
}
.report-text{
  font-size: 12px;
  align-items: center;
  gap:5px; 
  margin: 5px;
  width:100%;
}

.recent-card-text{
  font-size: 10px;
}
.report-card{
  gap:10px
}
}

@media (max-width: 1300px), (max-height: 850px) {

  .graph-card{
    padding-left: 1rem;
    padding-right: 1rem;
    height: 210px;
  }
  .overview-main{
    padding-top: 0px;
    padding-left: 15px;
    padding-right: 15px;
        gap:15px
  }
  .overview-header {
    padding-top: 8px;
  }
  .overview-card{
    height: 80px;

  }
  .report-card{
      padding: 13px;
  }                                            
  .report-main-card{
    height: 220px;
  }

  .card-align {
    padding-top: 14px;
}
.card-container{
  gap:15px;
}
.card-text {
  gap: 5px;
}
}`, "",{"version":3,"sources":["webpack://./src/pages/overview/overview.css"],"names":[],"mappings":"2EACA;EACE,8BAA8B,EAAE,gCAAgC;EAChE,+DAA2F;EAC3F,uFAAuF;AACzF;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;;IAEtB,QAAQ;IACR,mBAAmB;IACnB,oCAAoC;QAChC,WAAW;QACX,WAAW;MACb,gBAAgB;MAChB,8BAA8B;EAClC;;AAEF;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,YAAY;AACd;AACA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,UAAU;;EAEZ;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,iBAAiB;IACjB,8BAA8B;;EAEhC;AACF;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,6BAA6B;IAC7B,yBAAyB;IACzB,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV,aAAa;AACjB;;EAEE;IACE,aAAa;IACb,2CAA2C;IAC3C,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,iBAAiB;IACjB,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;EACE,4BAA4B;CAC7B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;;AAEjB;EACE;IACE;AACJ;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;;AAErB;;AAEA;AACA,eAAe;AACf,gBAAgB;AAChB,4BAA4B;AAC5B;;AAEA;EACE,uCAAuC;IACrC,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;EACE,uCAAuC;IACrC,0BAA0B;IAC1B,4BAA4B;IAC5B,8BAA8B;IAC9B,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB,EAAE,gDAAgD;EACrE,gBAAgB,EAAE,6BAA6B;EAC/C,uBAAuB;AACzB;AACA;IACI,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;;AAEZ;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;IACX,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB,EAAE,qFAAqF;AAC1G;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ,KAAK,YAAY;AAC3B;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B,EAAE,mCAAmC;AACnE;;AAEA;EACE,sBAAsB;;EAEtB;AACF;EACE,0BAA0B;AAC5B;;EAEE;AACF;EACE,wBAAwB;EACxB;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;MACI,0BAA0B;MAC1B,2BAA2B;EAC/B;;AAEF;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;AACA;EACE;AACF;EACE,8BAA8B;AAChC;;;AAGA;EACE,wBAAwB;EACxB;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,YAAY;;EAEd;EACA;MACI,0BAA0B;MAC1B,2BAA2B;EAC/B;;;;AAIF;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,OAAO;EACP,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;AACA;EACE;AACF;AACA;;AAEA;;EAEE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;QACf;EACN;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;;EAEd;EACA;MACI,aAAa;EACjB;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;AACA","sourcesContent":["                                                                           @import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\r\n@font-face {\r\n  font-family: 'PlusJakartaSans'; /* Choose a name for your font */\r\n  src: url('../../components/icons/PlusJakartaSans-VariableFont_wght.ttf') format('truetype');\r\n  /* Additional font properties can be specified, such as font-weight, font-style, etc. */\r\n}\r\n.overview-main{\r\n    padding-left: 25px;\r\n    padding-right: 25px;\r\n    padding-top: 10px;\r\n    display:flex;\r\n    flex-direction: column;\r\n\r\n    gap:20px;\r\n    align-items: center;\r\n    background-color: rgb(248, 248, 255);\r\n        width: 100%;\r\n        height:100%;\r\n      overflow-y: auto;    \r\n      font-family: 'PlusJakartaSans'; \r\n  }\r\n\r\n.card-text{\r\n  width: 65%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n.card-container{\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    gap:20px;\r\n    width:100%;\r\n\r\n  }\r\n\r\n  .report-card-container{\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap:30px;\r\n    padding-top: 10px;\r\n    font-family: 'PlusJakartaSans'; \r\n\r\n  }\r\n.graph-card{\r\n    /* margin-top: 25px; */\r\n    padding-left: 30px;\r\n    padding-right: 30px;\r\n    background: var(--Theme-Colors-White, #fff);\r\n    border-radius: 4px !important;\r\n    border: 1px solid #d6d6d6;\r\n    box-shadow: none !important;\r\n    font-family: 'PlusJakartaSans'; \r\n    width:100%;\r\n    height: 332px;\r\n}\r\n\r\n  .overview-card{\r\n    height: 105px;\r\n    background: var(--Theme-Colors-White, #fff);\r\n    border-radius: 11px !important;\r\n    border: 1px solid #d6d6d6;\r\n    box-shadow: none !important;\r\n  }\r\n  .heading-container{\r\n    padding-top: 10px;\r\n    display: flex;\r\n    width:100%;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n  }\r\n.heading{\r\n  font-family: PlusJakartaSans; \r\n font-size: 24px;\r\n font-style: normal;\r\n font-weight: 500;\r\n\r\n}\r\n  .overview-card-details{\r\n    margin:40px\r\n}\r\n\r\n.apexcharts-zoom-icon,\r\n.apexcharts-pan-icon,\r\n.apexcharts-reset-icon,\r\n.apexcharts-menu-icon {\r\n  display: none;\r\n}\r\n\r\n.card-img{\r\n  width: 30%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.card-align{\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: 23px;\r\n\r\n}\r\n\r\n.recent-card-text{\r\nfont-size: 12px;\r\nfont-weight: 500;\r\nfont-family: PlusJakartaSans;\r\n}\r\n\r\n.overview-card-text{\r\n  font-family: PlusJakartaSans !important; \r\n    font-size: 14px !important;\r\n    font-weight: 500 !important;\r\n}\r\n\r\n.overview-header{\r\n  font-family: PlusJakartaSans !important; \r\n    font-size: 16px !important;\r\n    font-weight: bold !important;\r\n    letter-spacing: 0em !important;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding-top: 15px;\r\n    margin-bottom: 0px;\r\n\r\n}\r\n\r\n.overview-card-defect{\r\n  font-family: PlusJakartaSans !important;\r\n  font-size: 18px !important;\r\n  font-weight: 600 !important;\r\n  letter-spacing: 0em !important;\r\n  white-space: nowrap; /* Prevent text from wrapping to the next line */\r\n  overflow: hidden; /* Hide any overflowed text */\r\n  text-overflow: ellipsis; \r\n}\r\n.card-count{\r\n    color: #000;\r\n    font-family: \"PlusJakartaSans\";\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: normal;\r\n}\r\n\r\n.card-image{\r\n    width: 45px;\r\n    height: 45px;\r\n}\r\n\r\n.card-content {\r\n  padding: 0px !important;\r\n  padding-bottom: 0px !important; \r\n}\r\n\r\n.report-main-card{\r\n  /* margin-top: 25px; */\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n  height: 230px;\r\n  background: var(--Theme-Colors-White, #fff);\r\n  border-radius: 4px !important;\r\n  border: 1px solid #d6d6d6;\r\n  box-shadow: none !important;\r\n  margin-bottom: 30px;\r\n  width:100%;\r\n\r\n}\r\n\r\n.report-card{\r\n  height: 158px;\r\n  background: var(--Theme-Colors-White, #fff);\r\n  border: 1px solid #d6d6d6;\r\n  box-shadow: none !important;\r\n  display: flex;\r\n  gap: 30px;\r\n  align-items: center;\r\n  padding: 20px;\r\n}\r\n\r\n.card-column{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.show-more-link{\r\n  display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.report-image {\r\n  height: 100%;\r\n  width: 100%;\r\n  border-radius: 8px;\r\n  object-fit: cover; /* This ensures the image covers the entire container, maintaining its aspect ratio */\r\n}\r\n\r\n.report-image-div{\r\n  height: 100%;\r\n  width: 40%;\r\n  border-radius: 8px;\r\n}\r\n.report-text-content{\r\n  width: 60%;\r\n}\r\n.report-text{\r\n  display: flex;\r\n  align-items: center;\r\n  gap:20px;    margin: 10px;\r\n}\r\n.apexcharts-canvas{\r\n  height:240px;\r\n  min-height:100%;\r\n}\r\n#chart-container .apexcharts-xaxis .apexcharts-gridline {\r\n  stroke-width: 0.1;\r\n}\r\n\r\n#chart-container .apexcharts-xaxis-line {\r\n  stroke-width: 0px !important; /* Adjust the thickness as needed */\r\n}\r\n\r\n.react-line-chart{\r\n  height: 85% !important}\r\n\r\n  @media screen and (max-width: 1800px) and (min-width: 1600px) {\r\n.overview-card-defect{\r\n  font-size: 16px !important;\r\n}\r\n    \r\n  }\r\n@media screen and (max-width: 1600px) and (min-width: 1350px) {\r\n  /* Your styles go here */\r\n  .overview-card-defect{\r\n    font-size: 14px !important;\r\n    font-weight: 600 !important;\r\n  }\r\n\r\n  .overview-card-text{\r\n      font-size: 12px !important;\r\n      font-weight: 500 !important;\r\n  }\r\n\r\n.recent-card-text{\r\n  font-size: 10px;\r\n}\r\n.report-text{\r\n  align-items: center;\r\n  gap:10px; \r\n  margin: 5px;\r\n  width:100%;\r\n}\r\n.report-card{\r\n  gap:15px\r\n}\r\n  /* Add more styles as needed */\r\n}\r\n\r\n\r\n@media screen and (max-width: 1350px) and (min-width: 1000px) {\r\n  /* Your styles go here */\r\n  .overview-card-defect{\r\n    font-size: 12px !important;\r\n    font-weight: 600 !important;\r\n  }\r\n  .overview-card{\r\n    height: 90px;\r\n\r\n  }\r\n  .overview-card-text{\r\n      font-size: 10px !important;\r\n      font-weight: 400 !important;\r\n  }\r\n\r\n\r\n\r\n.card-container {\r\n  gap:15px;\r\n  padding:0px;\r\n}\r\n.report-main-card{\r\n  height:208px;\r\n}\r\n.report-card-container{\r\n  padding-top:0.5rem;\r\n  padding-bottom:0.5rem;\r\n}\r\n.report-card{\r\n  height:auto;\r\n}\r\n.report-text{\r\n  font-size: 12px;\r\n  align-items: center;\r\n  gap:5px; \r\n  margin: 5px;\r\n  width:100%;\r\n}\r\n\r\n.recent-card-text{\r\n  font-size: 10px;\r\n}\r\n.report-card{\r\n  gap:10px\r\n}\r\n}\r\n\r\n@media (max-width: 1300px), (max-height: 850px) {\r\n\r\n  .graph-card{\r\n    padding-left: 1rem;\r\n    padding-right: 1rem;\r\n    height: 210px;\r\n  }\r\n  .overview-main{\r\n    padding-top: 0px;\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n        gap:15px\r\n  }\r\n  .overview-header {\r\n    padding-top: 8px;\r\n  }\r\n  .overview-card{\r\n    height: 80px;\r\n\r\n  }\r\n  .report-card{\r\n      padding: 13px;\r\n  }                                            \r\n  .report-main-card{\r\n    height: 220px;\r\n  }\r\n\r\n  .card-align {\r\n    padding-top: 14px;\r\n}\r\n.card-container{\r\n  gap:15px;\r\n}\r\n.card-text {\r\n  gap: 5px;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
